__turbopack_context__.v({
  "gamesCount": "advanced-sidebar-sport-module-sass-module__cUBzfW__gamesCount",
  "opened": "advanced-sidebar-sport-module-sass-module__cUBzfW__opened",
  "selected": "advanced-sidebar-sport-module-sass-module__cUBzfW__selected",
  "sportsNavItem": "advanced-sidebar-sport-module-sass-module__cUBzfW__sportsNavItem",
});
